const CONFIG = {
  DEV_MODE: false,
};

export default CONFIG;
